'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const SourceBarChart = dynamic(() => import('./SourceBarChart'), { ssr: false });
const LeadsByCheckpointChart = dynamic(() => import('./LeadsByCheckpointChart'), { ssr: false });

type DateRange = 7 | 30 | 90;

export default function DashboardCharts() {
  const [sourceDateRange, setSourceDateRange] = useState<DateRange>(7);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
      <div className="lg:col-span-2 bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h3 className="text-base font-semibold text-foreground">Leads by Checkpoint</h3>
          <p className="text-xs text-muted-foreground">Leads that reached each checkpoint</p>
        </div>
        <LeadsByCheckpointChart />
      </div>
      <div className="lg:col-span-1 bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h3 className="text-base font-semibold text-foreground">Leads by Source</h3>
          <p className="text-xs text-muted-foreground">Weekly comparison — MBBS Lighthouse vs GMC vs Neet Navigator</p>
        </div>
        <SourceBarChart dateRange={sourceDateRange} onDateRangeChange={setSourceDateRange} />
      </div>
    </div>
  );
}